




















































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Campaign } from '@/models/admin/campaign';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getCampaignHeaders } from '@/views/admin/campaign/campaignList';
import {campaignService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
        Stores: () => import('@/components/common/store.select.vue'),
    },
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
        isValidate() {
            // this.addDialog.action.disable = !this.name;
        },
    },
})
export default class CampaignListPage extends Base {
    public headers: VHeaders[] = getCampaignHeaders(this);
    public campaigns: Campaign[] = [];
    public campaign: Campaign = {};
    public addDialog: IDialogOption = {
        width: 500,
        title: '',
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: this.$parent.$t('campaigns.editCampaignDialog.btnSubmit') as string, disable: false },
        loading: false,
        onAction: (): void => {
            this.addOrUpdate();
        },
        onClose: (): void => {
            this.hideAddOrUpdateDialog();
        },
    };
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public name: string = '';
    public description: string = '';
    public storeId: number;
    public actions: any[] = [{
        type: 'button',
        icon: 'fas fa-edit',
        title: this.$parent.$t('campaigns.campaignsGrid.gridActions.edit') as string,
        action: (model: Campaign) => { this.showAddOrUpdateDialog(model); },
    },
    ];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: 'Confirm?',
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        onAction: (): void => {
            this.deleteCampaign();
        },
    };
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public campaignToDelete: Campaign = {};

    public created() {
        this.storeId = this.userSession.storeId;
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addCampaign') {
            this.showAddOrUpdateDialog(null);
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('campaigns.btnAddCampaigns'), disabled: false, visible: true, class: 'btn', label: this.$t('campaigns.btnAddCampaigns'), click: 'addCampaign', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'campaign');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getCampaigns();
        }
    }

    public async getCampaigns(): Promise<void> {
        try {
            this.loading = true;
            const campaigns = await campaignService.getCampaignsAsync(this.storeId);
            this.campaigns = campaigns.results;
            this.pagination.totalItems = campaigns.total;
        } finally {
            this.loading = false;
        }
    }

    public updatePaging(paging: PaginationModel) {
        this.pagination = paging;
    }

    public async addOrUpdate(): Promise<void> {
        if(this.validateForm()){
            if (this.campaign) {
                this.campaign.name = this.name;
                this.campaign.description = this.description;
                this.campaign.storeId = this.storeId;
            }
            if (!this.name) {
                return;
            }

            if (!this.campaign.id) {
                try {
                    this.addDialog.loading = true;
                    this.addDialog.action.disable = true;
                    await campaignService.addCampaignAsync(this.campaign);
                    this.getCampaigns();
                    this.showAlert(true, this.$t('campaigns.alertCampaignSavedSuccessfully'));
                } finally {
                    this.addDialog.action.disable = false;
                    this.addDialog.model = false;
                    this.addDialog.loading = false;
                }
            } else {
                try {
                    this.addDialog.loading = true;
                    this.addDialog.action.disable = true;
                    await campaignService.updateCampaignAsync(this.campaign);
                    this.getCampaigns();
                    this.showAlert(true, this.$t('campaigns.alertCampaignUpdatedSuccessfully'));
                } finally {
                    this.addDialog.model = false;
                    this.addDialog.action.disable = false;
                    this.addDialog.loading = false;
                }
            }
        }
    }

    public confirmDelete(item: Campaign): void {
        this.deleteDialog.model = true;
        this.campaignToDelete = item;
    }

    public async deleteCampaign(): Promise<void> {
        try {
            await campaignService.deleteCampaignAsync(this.campaignToDelete.id);
            this.showAlert(true, this.$t('campaigns.alertCampaignDeletedSuccessfully'));
            this.getCampaigns();
        } finally {
            this.deleteDialog.model = false;
        }
    }

    public showAddOrUpdateDialog(model: Campaign): void {
        if (model) {
            this.campaign = model;
            this.name = model.name;
            this.description = model.description;
            this.addDialog.title = this.$t('campaigns.editCampaignDialog.titleEdit') as string;
        } else {
            this.campaign = {};
            this.name = '';
            this.description = '';
            this.addDialog.title = this.$t('campaigns.editCampaignDialog.titleAdd') as string;
        }
        this.$validator.reset();
        this.addDialog.model = true;
    }

    public hideAddOrUpdateDialog(): void {
        this.$validator.reset();
        this.addDialog.model = false;
    }

    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getCampaigns();
    }
}
